<template>
	<div class="page" :style="{height:fixedHeight+'px'}">
		<!-- 搜索框 -->
		<div class="titleView">
			<div style="display: flex;align-items: center;">
				<el-input v-model="keyword" prefix-icon="el-icon-search" placeholder="请输入内容" class="titleInput"
					clearable size="small" @keyup.enter.native="handelSearchClick"/>
				<el-button type="warning" style="margin-left: 10px;" @click="handelSearchClick" size="small">搜索
				</el-button>
			</div>
			<div class="flex">
				<div class="m-r-10">状态</div>
				<el-select v-model="state" placeholder="请选择" class="titleSelect" @change="handelSearchClick"
					size="small">
					<el-option v-for="item in states" :key="item.value" :label="item.label"
						:value="item.value" />
				</el-select>
			</div>
			<div class="flex">
				<div class="m-r-10">门店</div>
				<el-select v-model="storeId" placeholder="请选择" class="titleSelect" @change="handelSearchClick"
					size="small">
					<el-option v-for="item in storeList" :key="item.shop_id" :label="item.shop_name"
						:value="item.shop_id"/>
				</el-select>
			</div>
			<div class="flex">
				<div class="m-r-10">职位</div>
				<el-select v-model="positionId" placeholder="请选择" class="titleSelect" @change="handelSearchClick"
					size="small">
					<el-option v-for="item in positionList" :key="item._id" :label="item.name" :value="item.name"/>
				</el-select>
			</div>
			<div style="flex: 1;display: flex;justify-content: flex-end;">
				<el-button class="addClick" @click="handleResetClick" size="small">重置</el-button>
				<el-button  type="warning" class="addClick" @click="handleUpdateClick(0)" size="small">新建员工</el-button>
			</div>
		</div>

		<!-- 表格 -->
		<div class="tableView">
			<el-table :data="tableData" style="width: 100%;" :default-sort = "{prop: 'date', order: 'descending'}">
				<el-table-column prop="basic_info.real_name" label="姓名">
				</el-table-column>
				<el-table-column prop="shopName" label="所属门店">
				</el-table-column>
				<el-table-column prop="archives_info.position" label="职位">
				</el-table-column>
				<el-table-column prop="basic_info.user_no" label="角色">
					<template slot-scope="scope">
						<div>
							{{scope.row.system_role?scope.row.system_role.title:'--'}}
						</div>
					</template>
				</el-table-column>
				<el-table-column prop="archives_info.sex" label="性别">
				</el-table-column>
				<el-table-column :prop="'basic_info.user_no'" label="员工编号" :sortable="true" :sort-method="sortByDate">
					<template slot-scope="scope" >
						<div>
							{{scope.row.basic_info.user_no ?scope.row.basic_info.user_no:'--'}}
						</div>
					</template>
				</el-table-column>
				<el-table-column prop="basic_info.user_mobile" label="手机号">
				</el-table-column>
				<el-table-column prop="basic_info.user_name" label="登录账号">
				</el-table-column>
				<el-table-column prop="archives_info.introduce" label="介绍" width="200px">
				</el-table-column>
				<el-table-column label="状态">
					<template slot-scope="scope">{{scope.row.status == 1?'在职':'离职'}}</template>
				</el-table-column>
				<el-table-column label="操作" width="250">
					<template slot-scope="scope">
						<el-button  @click="handleUpdateClick(1,scope.row)" type="text" size="small">编辑</el-button>
						<el-button  @click="handleRightClick(scope.row)" type="text" size="small">权限</el-button>
						<el-button  @click="handleOpenClick(scope.row)" type="text" size="small" v-if="scope.row.auth_info.o2o.member_id == ''">关联会员</el-button>
						<el-button  type="text" size="small" @click="handleDeleteClick(scope.row)">删除</el-button>
					</template>
				</el-table-column>
			</el-table>
			<!-- 分页 -->
			<page :page="page.page" :pageSize="page.pageSize" :total="page.total" @change="changePage" style="margin: 10px 0;"></page>
		</div>
		
		<!-- 员工弹框 -->
		<div v-if="drawerUpdateStaff_state">
			<drawerUpdateStaff @closeOn="updateStaffClose" :comState="drawerUpdateStaff_state" :navType="navType" :navData="navData">
			</drawerUpdateStaff>
		</div>
		<!-- 关联小程序 -->
		<el-dialog title="关联小程序" :visible.sync="dialogTypeStates" width="30%" :before-close="handleTypeClose">
			<div class="dialogContent">
				<div>小程序手机号:</div>
				<el-input v-model="comName" placeholder="请输入小程序手机号" size="small"></el-input>
				<el-button type="warning" size="small" style="margin-left: 10px;" @click="handleSousuoClick">搜索</el-button>
			</div>
			<div class="dialogMsg" style="text-align: center;color: red;line-height: 30px;">{{memberInfo == null?'暂未查询到会员信息,无法关联':`${memberInfo.basic_info.nick_name}可关联`}}</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dialogTypeStates = false" size="small">取 消</el-button>
				<el-button type="warning" @click="handleSubmitClick" size="small">关 联</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
	import drawerUpdateStaff from "./drawerUpdateStaff.vue"
	import page from "../../components/page.vue"
	export default {
		components: {
			page,
			drawerUpdateStaff
		},
		data() {
			return {
				page: {
					page: 1,
					pageSize: 10,
					total: 0
				},
				keyword: '', //搜索
				fixedHeight: '',
				tableData: [], //表格数据
				shopId:'',
				drawerUpdateStaff_state:false,
				positionId:'',  //职位
				positionList:[],
				storeId:'',
				storeList:[],  //门店列表
				state:1,  //状态
				states:[{label:'在职',value:1},{label:'离职',value:0}],  //状态列表
				navData:{},//跳转数据
				dialogTypeStates:false,
				comName:'',
				memberInfo:null,
				staffInfo:{}
			}
		},
		mounted() {
			this.fixedHeight = document.documentElement.clientHeight - 76;
			this.getTableData()
			this.getPositionData()
			this.getStoreData()
		},
		methods: {
			sortByDate(obj1, obj2) {
               let val1 = obj1.basic_info.user_no
               let val2 = obj2.basic_info.user_no
                return val1 - val2
            },
			//搜索
			handleSousuoClick(){
				let params = {
					mobile:this.comName
				}
				this.$http.get(process.env.VUE_APP_Url2 + 'api/MemberInfo',params).then(res => {
					if (res.code == 0) {
						this.memberInfo = res.data;
					}
				})
			},
			//打开弹框
			handleOpenClick(row){
				this.staffInfo = row;
				this.dialogTypeStates = true;
			},
			//关闭弹框
			handleTypeClose() {
				this.comName = '';
				this.dialogTypeStates = false;
			},
			//关联
			handleSubmitClick(){
				console.log(this.staffInfo,this.memberInfo)
				if(this.memberInfo == null){
					this.$message({
						type: 'error',
						message: '请查询到会员信息，进行关联'
					});
					return
				}
				let params = {
					staffId:this.staffInfo._id,
					memberId:this.memberInfo.memberId,
				}
				this.$http.post(process.env.VUE_APP_Url2 + 'api/StaffInfo/update/weixin',params).then(res => {
					if (res.code == 0) {
						this.$message({
							type: 'success',
							message: '已关联'
						});
						this.comName = '';
						this.getTableData()
						this.dialogTypeStates = false;
					}
				})
			},
			//删除
			handleDeleteClick(row){
				console.log(row)
				this.$confirm('是否删除该员工?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$http.delete(process.env.VUE_APP_Url2 + `api/StaffInfo/${row._id}`).then(res => {
						if (res.code == 0) {
							this.$message({
								type: 'success',
								message: '已删除'
							});
							this.getTableData();
						}
					})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});          
				});
			},
			//获取门店
			getStoreData(){
				let params = {
					companyId:'5e9412e0b2bfbc030160bdd5'
				}
				this.$http.get(process.env.VUE_APP_Url2 + 'api/CompanyInfo/shoplist',params).then(res => {
					if (res.code == 0) {
						this.storeList = res.data
					}
				})
			},
			//获取员工列表
			getPositionData(){
				this.$http.post(process.env.VUE_APP_Url2 + 'api/dict/StaffType/list').then(res => {
					if (res.code == 0) {
						console.log(res);
						this.positionList = res.data.data
					}
				})
			},
			// 编辑权限
			handleRightClick(row){
				let staff_info={id:row._id,name:row.basic_info.real_name} 

				this.$router.push({ path: 'UpdateRight',query:{
					staff_info:staff_info,
					row
				} })
            
			},
			//新增/编辑
			handleUpdateClick(type,row){
				
				this.navType = type;
				if(type == 1){   //编辑
					let params = {
						id:row._id
					}
					this.$http.get(process.env.VUE_APP_Url2 + 'api/StaffInfo/editmodel',params).then(res => {
						if (res.code == 0) {
							this.navData = res.data;
							this.drawerUpdateStaff_state = true;
						}
					})
				}else{
					this.drawerUpdateStaff_state = true;
				}
			},
			//关闭
			updateStaffClose(val){
				this.drawerUpdateStaff_state = false;
				if(val.type == 'submit'){
					this.getTableData()
				}
			},
			//重置
			handleResetClick() {
				this.page.page = 1;
				this.keyword = '';
				this.state = 1;
				this.storeId = '';
				this.positionId = '';
				this.handelSearchClick()
			},
			//搜索
			handelSearchClick() {
				this.page.page = 1;
				this.getTableData()
			},
			// 分页方法
			changePage(num) {
				this.page.page = num;
				this.getTableData();
			},
			//表格
			getTableData() {
				let params = {
					pageIndex: this.page.page,
					pageSize: this.page.pageSize,
					keyword: this.keyword,
					ownerShopId:this.storeId,
					position:this.positionId,
					status:this.state
				}
				this.$http.post(process.env.VUE_APP_Url2 + 'api/StaffInfo/list', params).then(res => {
					if (res.code == 0) {
						this.tableData = res.data.data;
						this.page.total = res.data.count
					}
				})
			},
		}
	}
</script>

<style lang="scss" scoped>
	.page {
		display: flex;
		flex-direction: column;
	}

	.titleView {
		height: 72px;
		line-height: 72px;
		display: flex;
		background: #fff;
		align-items: center;
		border-radius: 6px;
		margin-bottom: 10px;
		font-size: 12px;
		padding: 0 10px;

		.titleInput {
			width: 130px;
		}

		.titleDate {
			width: 340px;
		}

		.titleSelect {
			width: 100px;
		}
	}

	.flex {
		display: flex;
		align-items: center;
		margin-left: 10px;
	}

	.m-r-10 {
		margin-right: 10px;
		font-size: 12px;
	}

	.tableView {
		padding-bottom: 10px;
		background: #fff;
		flex: 1;
	}
	.dialogContent{
		display: flex;
		align-items: center;
		div:nth-of-type(1){
			margin-right: 8px;
			width: 100px;
			font-weight: bold;
			text-align: right;
		}
		div:nth-of-type(2){
			width: 200px;
		}
	}
</style>
